webpackJsonp([88746230898986],{

/***/ "./src/components/contact/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icon = __webpack_require__("./src/components/icon/index.jsx");
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _outboundLink = __webpack_require__("./src/components/outbound-link/index.jsx");
	
	var _outboundLink2 = _interopRequireDefault(_outboundLink);
	
	var _stylesModule = __webpack_require__("./src/components/contact/styles.module.css");
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(_ref) {
	  var title = _ref.title;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.contact },
	    _react2.default.createElement(
	      'h1',
	      null,
	      title || 'I like messages.'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: _stylesModule2.default.email },
	      'Say hello and send an email:',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:mike@nongaap.com?subject=Hello%20Mike!', className: _stylesModule2.default.link },
	        'mike@nongaap.com'
	      )
	    ),
	    _react2.default.createElement('div', { className: _stylesModule2.default.lineBreak }),
	    _react2.default.createElement(
	      'ul',
	      { className: _stylesModule2.default.social },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _outboundLink2.default,
	          { to: 'https://github.com/nongaap/' },
	          _react2.default.createElement(_icon2.default, { name: 'github' })
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _outboundLink2.default,
	          { to: 'https://www.linkedin.com/in/nongaap' },
	          _react2.default.createElement(_icon2.default, { name: 'linkedin' })
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _outboundLink2.default,
	          { to: 'https://twitter.com/nongaap/' },
	          _react2.default.createElement(_icon2.default, { name: 'twitter' })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/contact/styles.module.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contact":"src-components-contact----styles-module---contact---13_aX","lineBreak":"src-components-contact----styles-module---lineBreak---1yPvS","email":"src-components-contact----styles-module---email---3rLgN","link":"src-components-contact----styles-module---link---3_9I0","social":"src-components-contact----styles-module---social---1BgLN"};

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./github.svg": "./src/components/icon/svg/github.svg",
		"./linkedin.svg": "./src/components/icon/svg/linkedin.svg",
		"./twitter.svg": "./src/components/icon/svg/twitter.svg"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1;


/***/ }),

/***/ "./src/components/content-page/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stylesModule = __webpack_require__("./src/components/content-page/styles.module.css");
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ContentPage = function ContentPage(_ref) {
	  var props = _objectWithoutProperties(_ref, []),
	      children = _ref.children,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'section',
	    _extends({}, props, { className: (0, _classnames2.default)(_stylesModule2.default.content, className) }),
	    children
	  );
	};
	
	exports.default = ContentPage;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/content-page/styles.module.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"src-components-content-page----styles-module---content---2gEBQ"};

/***/ }),

/***/ "./src/components/icon/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stylesModule = __webpack_require__("./src/components/icon/styles.module.css");
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icon = function Icon(_ref) {
	  var className = _ref.className,
	      name = _ref.name;
	
	  var src = __webpack_require__(1)("./" + name + '.svg');
	
	  return _react2.default.createElement('img', { src: src, className: (0, _classnames2.default)(_stylesModule2.default.icon, className), alt: name + ' icon' });
	};
	
	exports.default = Icon;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/icon/styles.module.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"src-components-icon----styles-module---icon---2zdnD"};

/***/ }),

/***/ "./src/components/icon/svg/github.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CjxnIGlkPSJpY29tb29uLWlnbm9yZSI+CjwvZz4KPHBhdGggZD0iTTI1Ni4wMDQgNi4zMjFjLTE0MS4zNjkgMC0yNTYuMDA0IDExNC42MDktMjU2LjAwNCAyNTUuOTk5IDAgMTEzLjEwNyA3My4zNTIgMjA5LjA2NiAxNzUuMDY4IDI0Mi45MTggMTIuNzkzIDIuMzY5IDE3LjQ5Ni01LjU1NSAxNy40OTYtMTIuMzE2IDAtNi4xMDItMC4yNC0yNi4yNzEtMC4zNDgtNDcuNjYyLTcxLjIyNCAxNS40ODgtODYuMjUyLTMwLjIwNS04Ni4yNTItMzAuMjA1LTExLjY0MS0yOS41ODgtMjguNDI0LTM3LjQ1OC0yOC40MjQtMzcuNDU4LTIzLjIyNi0xNS44ODkgMS43NTUtMTUuNTYyIDEuNzU1LTE1LjU2MiAyNS43IDEuODA1IDM5LjIzOCAyNi4zODMgMzkuMjM4IDI2LjM4MyAyMi44MzYgMzkuMTM1IDU5Ljg4OCAyNy44MiA3NC41MDIgMjEuMjc5IDIuMjk0LTE2LjU0MyA4LjkyNi0yNy44NCAxNi4yNTMtMzQuMjMyLTU2Ljg2NS02LjQ3MS0xMTYuNjM4LTI4LjQyNS0xMTYuNjM4LTEyNi41MTYgMC0yNy45NDkgMTAuMDAyLTUwLjc4NyAyNi4zOC02OC43MTQtMi42NTgtNi40NS0xMS40MjctMzIuNDg2IDIuNDc2LTY3Ljc1IDAgMCAyMS41MDMtNi44NzYgNzAuNDIgMjYuMjQ1IDIwLjQxOC01LjY3NCA0Mi4zMTgtOC41MTggNjQuMDc3LTguNjE3IDIxLjc1MSAwLjA5OSA0My42NjggMi45NDMgNjQuMTI4IDguNjE3IDQ4Ljg2Ny0zMy4xMjIgNzAuMzI4LTI2LjI0NSA3MC4zMjgtMjYuMjQ1IDEzLjkzNiAzNS4yNjQgNS4xNzUgNjEuMyAyLjUxOCA2Ny43NSAxNi40MSAxNy45MjggMjYuMzQ3IDQwLjc2NiAyNi4zNDcgNjguNzE0IDAgOTguMzI3LTU5Ljg4OSAxMTkuOTc1LTExNi44OTUgMTI2LjMxMiA5LjE4MiA3Ljk0NSAxNy4zNjIgMjMuNTIzIDE3LjM2MiA0Ny40MDYgMCAzNC4yNTQtMC4yOTggNjEuODIyLTAuMjk4IDcwLjI1NCAwIDYuODE0IDQuNjExIDE0Ljc5NyAxNy41ODYgMTIuMjgzIDEwMS42NjEtMzMuODg4IDE3NC45MjEtMTI5LjgxMyAxNzQuOTIxLTI0Mi44ODQgMC0xNDEuMzktMTE0LjYxNy0yNTUuOTk5LTI1NS45OTYtMjU1Ljk5OXoiPjwvcGF0aD4KPC9zdmc+Cg=="

/***/ }),

/***/ "./src/components/icon/svg/linkedin.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CjxnIGlkPSJpY29tb29uLWlnbm9yZSI+CjwvZz4KPHBhdGggZD0iTTE5MiAxOTJoODguNTUzdjQ1LjM5MWgxLjI2NmMxMi4zMi0yMi4wOTcgNDIuNDc5LTQ1LjM5MSA4Ny40MjEtNDUuMzkxIDkzLjQ3MyAwIDExMC43NiA1OC4xODggMTEwLjc2IDEzMy44Njd2MTU0LjEzM2gtOTIuMzA1di0xMzYuNjM5YzAtMzIuNTkyLTAuNjY3LTc0LjUxMy00OC4wMTQtNzQuNTEzLTQ4LjA3NCAwLTU1LjQxIDM1LjQ5My01NS40MSA3Mi4xNDZ2MTM5LjAwNmgtOTIuMjcxdi0yODh6Ij48L3BhdGg+CjxwYXRoIGQ9Ik0zMiAxOTJoOTZ2Mjg4aC05NnYtMjg4eiI+PC9wYXRoPgo8cGF0aCBkPSJNMTI4IDExMmMwIDI2LjUxLTIxLjQ5IDQ4LTQ4IDQ4cy00OC0yMS40OS00OC00OGMwLTI2LjUxIDIxLjQ5LTQ4IDQ4LTQ4czQ4IDIxLjQ5IDQ4IDQ4eiI+PC9wYXRoPgo8L3N2Zz4K"

/***/ }),

/***/ "./src/components/icon/svg/twitter.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CjxnIGlkPSJpY29tb29uLWlnbm9yZSI+CjwvZz4KPHBhdGggZD0iTTUxMiAxMTMuMmMtMTguOCA4LjQtMzkuMSAxNC02MC4zIDE2LjUgMjEuNy0xMyAzOC4zLTMzLjYgNDYuMi01OC4xLTIwLjMgMTItNDIuOCAyMC44LTY2LjcgMjUuNS0xOS4yLTIwLjQtNDYuNS0zMy4xLTc2LjctMzMuMS01OCAwLTEwNSA0Ny0xMDUgMTA1IDAgOC4yIDAuOSAxNi4yIDIuNyAyMy45LTg3LjMtNC40LTE2NC43LTQ2LjItMjE2LjUtMTA5LjgtOSAxNS41LTE0LjIgMzMuNi0xNC4yIDUyLjggMCAzNi40IDE4LjUgNjguNiA0Ni43IDg3LjQtMTcuMi0wLjUtMzMuNC01LjMtNDcuNi0xMy4xIDAgMC40IDAgMC45IDAgMS4zIDAgNTAuOSAzNi4yIDkzLjQgODQuMyAxMDMtOC44IDIuNC0xOC4xIDMuNy0yNy43IDMuNy02LjggMC0xMy4zLTAuNy0xOS44LTEuOSAxMy40IDQxLjcgNTIuMiA3Mi4xIDk4LjEgNzMtMzYgMjguMi04MS4yIDQ1LTEzMC41IDQ1LTguNSAwLTE2LjgtMC41LTI1LjEtMS41IDQ2LjYgMjkuOSAxMDEuOCA0Ny4yIDE2MS4xIDQ3LjIgMTkzLjIgMCAyOTguOS0xNjAuMSAyOTguOS0yOTguOSAwLTQuNi0wLjEtOS4xLTAuMy0xMy42IDIwLjUtMTQuNyAzOC4zLTMzLjIgNTIuNC01NC4zeiI+PC9wYXRoPgo8L3N2Zz4K"

/***/ }),

/***/ "./src/components/outbound-link/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OutboundLink = function OutboundLink(props) {
	  return _react2.default.createElement(
	    "a",
	    _extends({}, props, { href: props.to, target: "_blank", rel: "noopener noreferrer" }),
	    props.children
	  );
	};
	
	exports.default = OutboundLink;
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/puangmalai/Desktop/hiimp/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/puangmalai/Desktop/hiimp/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/puangmalai/Desktop/hiimp/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/puangmalai/Desktop/hiimp/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/puangmalai/Desktop/hiimp/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/puangmalai/Desktop/hiimp/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/contact/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contentPage = __webpack_require__("./src/components/content-page/index.jsx");
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _contact = __webpack_require__("./src/components/contact/index.jsx");
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _meta = __webpack_require__("./src/components/meta/index.jsx");
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _wrapper = __webpack_require__("./src/components/wrapper/index.jsx");
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage(_ref) {
	  var location = _ref.location;
	  return _react2.default.createElement(
	    _contentPage2.default,
	    null,
	    _react2.default.createElement(_meta2.default, { title: 'Contact', description: 'If you have an upcoming project you\'d like to talk about or are looking to collaborate and build something special, say hello and send an email.', location: location }),
	    _react2.default.createElement(
	      _wrapper2.default,
	      null,
	      _react2.default.createElement(_contact2.default, null)
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-index-jsx-9bae26042e9dacb47bd2.js